
import { Expose } from "class-transformer";

export class WeatherData {

  @Expose({ name: 'weather_month' })
  public weatherMonth!: number;

  @Expose({ name: 'weather_year' })
  public weatherYear!: number;

  @Expose({ name: 'weather_median' })
  public weatherMedian!: number;

  @Expose({ name: 'weather_std' })
  public weatherStd!: number;
  
  @Expose({ name: 'inputs' })
  public inputs!: number;

}
